import { render, staticRenderFns } from "./floatingWindowPop.vue?vue&type=template&id=4b5cccd4&scoped=true"
import script from "./floatingWindowPop.vue?vue&type=script&lang=js"
export * from "./floatingWindowPop.vue?vue&type=script&lang=js"
import style0 from "./floatingWindowPop.vue?vue&type=style&index=0&id=4b5cccd4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5cccd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b5cccd4')) {
      api.createRecord('4b5cccd4', component.options)
    } else {
      api.reload('4b5cccd4', component.options)
    }
    module.hot.accept("./floatingWindowPop.vue?vue&type=template&id=4b5cccd4&scoped=true", function () {
      api.rerender('4b5cccd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/appNewRenovation/home/components/floatingWindowPop.vue"
export default component.exports